import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store'
import './assets/styles/common.less'
import Vconsole from 'vconsole'
import { query } from './utils/device'

if (process.env.VUE_APP_SDK_TYPE === 'DEV' && query?.version !== 'release')
  new Vconsole()

createApp(App).use(router).use(store).mount('#app')
